if (typeof global === "undefined" && typeof window !== "undefined" && !window.global) {
  window.global = window;
}
//# sourceMappingURL=polyfills.js.map